
intra_module.factory('File', function($resource, api_url) {
    const url     = `${api_url}/students/files`;
    const params  = { };
    const actions = { };

    return $resource(url, params, actions);
});
